<template>
	<div class="contact-card" v-if="contactCard">
		<h3 class="title" v-if="contactCard.title">
			{{contactCard.title}}
		</h3>
		<div class="subtitle" v-if="contactCard.subtitle">
			{{contactCard.subtitle}}
		</div>
		<div class="contact-links">
			<a :href="contactCard.phone.href" class="contact-link" v-if="contactCard.phone">
				<img :src="contactCard.phone.imgSrc" :alt="contactCard.phone.imgAlt" />
				<span>
					{{contactCard.phone.text}}
				</span>
			</a>
			<a :href="contactCard.email.href" class="contact-link" v-if="contactCard.email">
				<img :src="contactCard.email.imgSrc" :alt="contactCard.email.imgAlt" />
				<span>
					{{contactCard.email.text}}
				</span>
			</a>
			<a :href="contactCard.website.href" class="contact-link website" v-if="contactCard.website">
				<img :src="contactCard.website.imgSrc" :alt="contactCard.website.imgAlt" />
				<span>
					{{contactCard.website.text}}
				</span>
				<svg version="1.1" class="icon-arrow-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve">
					<path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z" />
				</svg>
			</a>
			<div class="social-icons">
				<a :key="item.id" v-for="item in contactCard.social" :href="item.href" class="social">
					<img :src="item.imgSrc" :alt="item.imgAlt" />
				</a>
			</div>
		</div>
	</div>
</template>

<script>

	
	export default {
		name: 'ContactCard',
		
		props: ['contactCard']
	}
	
</script>